import React from 'react';

export default function LoginModal() {
  function handleSignIn() {
    window.location.href = '/api/auth/login';
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/60 backdrop-blur-sm p-4">
      <div className="w-full max-w-sm rounded-2xl bg-white shadow-2xl">
        <div className="px-8 py-8">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-600 shadow">
                <svg className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zm6-4a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zm6-3a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
                </svg>
              </div>
              <div>
                <div className="text-base font-bold text-gray-900 leading-tight">Contractor Super</div>
                <div className="text-xs text-gray-400 leading-tight">invoicepolish.com</div>
              </div>
            </div>
          </div>

          <h1 className="text-center text-xl font-bold text-gray-900 mb-1">Sign in</h1>
          <p className="text-center text-sm text-gray-500 mb-6">
            Use your InvoicePolish account to continue.
          </p>

          <button
            type="button"
            onClick={handleSignIn}
            className="btn-primary w-full py-3"
          >
            Sign in with InvoicePolish
          </button>
        </div>
      </div>
    </div>
  );
}
